export const ACTIONS = {
  USER_SIGNUP: "USER_SIGNUP",
  USER_LOGIN: "USER_LOGIN",
  CREATE_PATIENT: "CREATE_PATIENT",
  UPDATE_PATIENT: "UPDATE_PATIENT",
  DELETE_PATIENT: "DELETE_PATIENT",
  UPLOAD_PDF: "UPLOAD_PDF",
  VIEW_PDF: "VIEW_PDF",
  DOWNLOAD_PDF: "DOWNLOAD_PDF",
  DELETE_PDF: "DELETE_PDF",
  REQUEST_ACCESS: "REQUEST_ACCESS",
  APPROVE_ACCESS: "APPROVE_ACCESS",
  REJECT_ACCESS: "REJECT_ACCESS",
  DELETE_USER_ACCOUNT: "DELETE_USER_ACCOUNT",
};

export const ACTION_STYLE_MAP = {
  UPLOAD_PDF: "badge-success",
  CREATE_PATIENT: "badge-success",
  UPDATE_PATIENT: "badge-pending",
  VIEW_PDF: "badge-admin",
  DOWNLOAD_PDF: "badge-admin",
  DELETE_PDF: "badge-error",
  DELETE_PATIENT: "badge-error",
  USER_LOGIN: "badge-neutral",
  USER_SIGNUP: "badge-neutral",
  REQUEST_ACCESS: "badge-pending",
  APPROVE_ACCESS: "badge-success",
  REJECT_ACCESS: "badge-error",
  DELETE_USER_ACCOUNT: "badge-error",
};
